import { lazy, Suspense } from 'react';
import LoadingScreen from './common/LoadingScreen';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import TeacherViewExamTHPTQG from 'views/TeacherViewExamTHPTQG';
import ScrollToTop from './components/ScrollToTop';
// import {
//   SignIn as SignInView,
//   SignOut as SignOutView,
//   NotFound as NotFoundView,
//   //Guide as GuideView,
//   ForgotPassword as ForgotPasswordView,
//   Register as RegisterView,
//   RegisterOTP as RegisterOTPView,
//   RegisterPassword as RegisterPasswordView,
//   RegisterInfoPhone as RegisterInfoPhoneView,
//   StudentIndex as StudentIndexView,
//   StudentHistory as StudentHistoryView,
//   StudentExam as StudentExamView,
//   StudentViewExam as StudentViewExamView,
//   TeacherKhoi as TeacherKhoiView,
//   TeacherKhoiTaoPhongThi as TeacherKhoiTaoPhongThiView,
//   TeacherLop as TeacherLopView,
//   TeacherXuLyTinhHuongThi as TeacherXuLyTinhHuongThiView,
//   TeacherDiem as TeacherDiemView,
//   TeacherDiemDanhSach as TeacherDiemDanhSachView,
//   TeacherDiemChiTiet as TeacherDiemChiTietView,
//   TeacherDeThiCanLam as TeacherDeThiCanLamView,
//   TeacherDeThi as TeacherDeThiView,
//   TeacherTryExam as TeacherTryExamView,
//   TeacherDeThiDanhSachCauHoi as TeacherDeThiDanhSachCauHoiView,
//   TeacherDeThiDanhSachCauHoiCapNhat as TeacherDeThiDanhSachCauHoiCapNhatView,
//   TeacherLopChiTiet as TeacherLopChiTietView,
//   ChangePasswordOTP as ChangePasswordOTPView,
//   ChangePasswordUser as ChangePasswordUserView,

//   TeacherStepThemHocSinh as TeacherStepThemHocSinhView,
//   TeacherStepThemHocSinhPhong as TeacherStepThemHocSinhPhongView,
//   TeacherStepUploadDe as TeacherStepUploadDeView,
//   TeacherStepChuyenDe as TeacherStepChuyenDeView,
//   TeacherQLKyThi as TeacherQLKyThiView,
//   TeacherQLMon as TeacherQLMonView,
//   UpdateUserInfo as UpdateUserInfoView,
//   TeacherViewExam as TeacherViewExamView,
//   TeacherHanhTrinhLamBai as TeacherHanhTrinhLamBaiView,
//   TeacherScoreExamEssay as TeacherScoreExamEssayView,
//   TeacherIndexEssay as TeacherIndexEssayView,
//   TeacherChuaChamDiem as TeacherChuaChamDiemView,
//   TeacherDaChamDiem as TeacherDaChamDiemView,
//   TeacherDeThiTuLuan as TeacherDeThiTuLuanView,
//   PageTesting as PageTestingView,
//   TeacherListTeacher as TeacherListTeacherView,
//   TeacherPrintExam as TeacherPrintExamView,
//   TeacherListTransfer as TeacherListTransferView,
//   TeacherManageClass as TeacherManageClassView,
//   TeacherTaoDeThiTuNganHang as TeacherTaoDeThiTuNganHangView,
//   StudentDocument as StudentDocumentView

// } from './views';

import SignIn from './views/SignIn/index';
const SignOut = lazy(() => import('./views/SignOut/index'));
const NotFound = lazy(() => import('./views/NotFound/index'));
const SsoError = lazy(() => import('./views/SsoError/index'));
const NotSupportRole = lazy(() => import('./views/NotSupportRole/index'));
//const TrangChu = lazy(() => import('./views/TrangChu/index'));
//const Guide = lazy(() => import('./views/Guide/index'));
const ForgotPassword = lazy(() => import('./views/ForgotPassword/index'));
const Register = lazy(() => import('./views/Register/index'));
const RegisterOTP = lazy(() => import('./views/RegisterOTP/index'));
const RegisterPassword = lazy(() => import('./views/RegisterPassword/index'));
const RegisterInfoPhone = lazy(() => import('./views/RegisterInfoPhone/index'));
const StudentIndex = lazy(() => import('./views/StudentIndex/index'));
const StudentHistory = lazy(() => import('./views/StudentHistory/index'));
const StudentExam = lazy(() => import('./views/StudentExam/index'));
const StudentViewExam = lazy(() => import('./views/StudentViewExam/index'));
const StudentViewExamTHPT2025 = lazy(
  () => import('./views/StudentViewExamTHPT2025/index')
);
const TeacherKhoi = lazy(() => import('./views/TeacherKhoi/index'));
const TeacherKhoiTaoPhongThi = lazy(
  () => import('./views/TeacherKhoiTaoPhongThi/index')
);
const TeacherLop = lazy(() => import('./views/TeacherLop/index'));
const TeacherXuLyTinhHuongThi = lazy(
  () => import('./views/TeacherXuLyTinhHuongThi/index')
);
const TeacherDiem = lazy(() => import('./views/TeacherDiem/index'));
const TeacherDiemDanhSach = lazy(
  () => import('./views/TeacherDiemDanhSach/index')
);
const TeacherDiemChiTiet = lazy(
  () => import('./views/TeacherDiemChiTiet/index')
);
const TeacherDeThiCanLam = lazy(
  () => import('./views/TeacherDeThiCanLam/index')
);
const TeacherDeThi = lazy(() => import('./views/TeacherDeThi/index'));
const TeacherTryExam = lazy(() => import('./views/TeacherTryExam/index'));
const TeacherTryExamTHPTQG = lazy(
  () => import('./views/TeacherTryExamTHPTQG/index')
);
const TeacherDeThiDanhSachCauHoi = lazy(
  () => import('./views/TeacherDeThiDanhSachCauHoi/index')
);
const TeacherDeThiDanhSachCauHoiCapNhat = lazy(
  () => import('./views/TeacherDeThiDanhSachCauHoiCapNhat/index')
);
const TeacherDeThiDanhSachCauHoiCapNhatTHPT2025 = lazy(
  () => import('./views/TeacherDeThiDanhSachCauHoiCapNhatTHPT2025/index')
);
const TeacherLopChiTiet = lazy(() => import('./views/TeacherLopChiTiet/index'));
const ChangePasswordOTP = lazy(() => import('./views/ChangePasswordOTP/index'));
const ChangePasswordUser = lazy(
  () => import('./views/ChangePasswordUser/index')
);
const TeacherStepThemHocSinh = lazy(
  () => import('./views/TeacherStepThemHocSinh/index')
);
const TeacherStepThemHocSinhPhong = lazy(
  () => import('./views/TeacherStepThemHocSinhPhong/index')
);
const TeacherStepUploadDe = lazy(
  () => import('./views/TeacherStepUploadDe/index')
);
const TeacherStepUploadDeTHPTQG = lazy(
  () => import('./views/TeacherStepUploadDeTHPTQG/index')
);
const TeacherStepChuyenDe = lazy(
  () => import('./views/TeacherStepChuyenDe/index')
);
const TeacherQLKyThi = lazy(() => import('./views/TeacherQLKyThi/index'));
const TeacherQLMon = lazy(() => import('./views/TeacherQLMon/index'));
const UpdateUserInfo = lazy(() => import('./views/UpdateUserInfo/index'));
const TeacherViewExam = lazy(() => import('./views/TeacherViewExam/index'));
const TeacherHanhTrinhLamBai = lazy(
  () => import('./views/TeacherHanhTrinhLamBai/index')
);
const TeacherScoreExamEssay = lazy(
  () => import('./views/TeacherScoreExamEssay/index')
);
const TeacherIndexEssay = lazy(() => import('./views/TeacherIndexEssay/index'));
const TeacherChuaChamDiem = lazy(
  () => import('./views/TeacherChuaChamDiem/index')
);
const TeacherDaChamDiem = lazy(() => import('./views/TeacherDaChamDiem/index'));
const TeacherDeThiTuLuan = lazy(
  () => import('./views/TeacherDeThiTuLuan/index')
);
const PageTesting = lazy(() => import('./views/PageTesting/index'));
const TeacherListTeacher = lazy(
  () => import('./views/TeacherListTeacher/index')
);
const TeacherPrintExam = lazy(() => import('./views/TeacherPrintExam/index'));
const TeacherListTransfer = lazy(
  () => import('./views/TeacherListTransfer/index')
);
const TeacherManageClass = lazy(
  () => import('./views/TeacherManageClass/index')
);
const TeacherTaoDeThiTuNganHang = lazy(
  () => import('./views/TeacherTaoDeThiTuNganHang/index')
);
const StudentDocument = lazy(() => import('./views/StudentDocument/index'));
const TeacherXuLyPhieuTraLoi = lazy(
  () => import('./views/TeacherXuLyPhieuTraLoi/index')
);
const TeacherMauPhieuCham = lazy(
  () => import('./views/TeacherMauPhieuCham/index')
);
const TeacherDSMauPhieuCham = lazy(
  () => import('./views/TeacherDSMauPhieuCham/index')
);
const GradingRoundDetailView = lazy(
  () => import('./views/TeacherXuLyPhieuTraLoi/GradingRoundDetailView')
);

const StudentExamTHPT2025 = lazy(() => import('./views/StudentExamTHPT2025'));
const StudentExamModule = lazy(() => import('./views/StudentExamModule'));

const Home = lazy(() => import('./views/Home/index'));
const PointManagement = lazy(() => import('./views/PointManagement/index'));
const Routes = (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <ScrollToTop />
      <Switch>
        <RouteWithLayout
          component={SignIn}
          layout={MinimalLayout}
          path="/dang-nhap"
        />
        {/* <RouteWithLayout
          component={Guide}
          exact
          layout={MinimalLayout}
          path="/huong-dan"
        /> */}
        <RouteWithLayout
          component={SignOut}
          layout={MinimalLayout}
          path="/thoat"
        />
        <RouteWithLayout
          component={ForgotPassword}
          exact
          layout={MinimalLayout}
          path="/quen-mat-khau"
        />
        <RouteWithLayout
          component={Register}
          exact
          layout={MinimalLayout}
          path="/dang-ky-tai-khoan"
        />
        <RouteWithLayout
          component={RegisterOTP}
          exact
          layout={MinimalLayout}
          path="/dang-ky-tai-khoan-otp"
        />
        <RouteWithLayout
          component={RegisterPassword}
          exact
          layout={MinimalLayout}
          path="/tao-mat-khau"
        />
        <RouteWithLayout
          component={RegisterInfoPhone}
          exact
          layout={MinimalLayout}
          path="/dang-ky-thong-tin"
        />
        <RouteWithLayout
          component={ChangePasswordOTP}
          exact
          layout={MinimalLayout}
          path="/cap-nhat-mat-khau"
        />
        <RouteWithLayout
          component={ChangePasswordUser}
          exact
          layout={MinimalLayout}
          path="/doi-mat-khau"
        />
        <RouteWithLayout
          component={TeacherTryExam}
          exact
          layout={MainLayout}
          path="/thi-thu"
        />
        <RouteWithLayout
          component={TeacherTryExamTHPTQG}
          exact
          layout={MainLayout}
          path="/thi-thu-thpt-qg"
        />
        {/* student */}
        <RouteWithLayout
          component={StudentIndex}
          exact
          layout={MainLayout}
          path="/phong-thi-truc-tuyen"
        />
        <RouteWithLayout
          component={StudentHistory}
          exact
          layout={MainLayout}
          path="/lich-su-thi"
        />
        <RouteWithLayout
          // component={StudentExam}
          component={StudentExamModule}
          exact
          layout={MainLayout}
          path="/thi"
        />
        <RouteWithLayout
          // component={StudentExamTHPT2025}
          component={StudentExamModule}
          exact
          layout={MainLayout}
          path="/thi-thpt-2025"
        />
        <RouteWithLayout
          component={StudentViewExam}
          exact
          layout={MainLayout}
          path="/xem-ket-qua"
        />
        <RouteWithLayout
          component={StudentViewExamTHPT2025}
          exact
          layout={MainLayout}
          path="/xem-ket-qua-2025"
        />
        <RouteWithLayout
          component={UpdateUserInfo}
          exact
          //layout={MainLayout}
          layout={MinimalLayout}
          path="/thong-tin-tai-khoan"
        />
        {/* end student */}

        {/* teacher */}
        <RouteWithLayout
          component={TeacherKhoi}
          exact
          layout={MainLayout}
          path="/khoi"
        />
        <RouteWithLayout
          component={TeacherKhoiTaoPhongThi}
          exact
          layout={MainLayout}
          path="/khoi-tao-phong-thi"
        />
        <RouteWithLayout
          component={TeacherStepThemHocSinh}
          exact
          layout={MainLayout}
          path="/step-them-hoc-sinh"
        />
        <RouteWithLayout
          component={TeacherStepThemHocSinhPhong}
          exact
          layout={MainLayout}
          path="/step-them-hoc-sinh-phong"
        />
        <RouteWithLayout
          component={TeacherStepUploadDe}
          exact
          layout={MainLayout}
          path="/step-upload-de-thi"
        />
        <RouteWithLayout
          component={TeacherStepUploadDeTHPTQG}
          exact
          layout={MainLayout}
          path="/step-upload-de-thi-thptqg"
        />
        <RouteWithLayout
          component={TeacherStepChuyenDe}
          exact
          layout={MainLayout}
          path="/step-chuyen-de"
        />

        <RouteWithLayout
          component={TeacherLop}
          exact
          layout={MainLayout}
          path="/lop"
        />
        <RouteWithLayout
          component={TeacherLopChiTiet}
          exact
          layout={MainLayout}
          path="/chi-tiet-lop"
        />
        <RouteWithLayout
          component={TeacherXuLyTinhHuongThi}
          exact
          layout={MainLayout}
          path="/xu-ly-tinh-huong-thi"
        />
        {/* <RouteWithLayout
          component={TeacherDiem}
          exact
          layout={MainLayout}
          path="/quan-ly-diem"
        /> */}
        <RouteWithLayout
          component={PointManagement}
          exact
          layout={MainLayout}
          path="/quan-ly-diem"
        />
        <RouteWithLayout
          component={TeacherDiemDanhSach}
          exact
          layout={MainLayout}
          path="/diem-danh-sach"
        />
        <RouteWithLayout
          component={TeacherDiemChiTiet}
          exact
          layout={MainLayout}
          path="/chi-tiet-diem"
        />
        <RouteWithLayout
          component={TeacherDeThiCanLam}
          exact
          layout={MainLayout}
          path="/de-thi-can-lam"
        />
        <RouteWithLayout
          component={TeacherDeThi}
          exact
          layout={MainLayout}
          path="/de-thi"
        />
        <RouteWithLayout
          component={TeacherDeThiDanhSachCauHoi}
          exact
          layout={MainLayout}
          path="/danh-sach-cau-hoi"
        />
        <RouteWithLayout
          component={TeacherDeThiDanhSachCauHoiCapNhat}
          exact
          layout={MainLayout}
          path="/cap-nhat-cau-hoi"
        />
        <RouteWithLayout
          component={TeacherDeThiDanhSachCauHoiCapNhatTHPT2025}
          exact
          layout={MainLayout}
          path="/cap-nhat-cau-hoi-thptqg"
        />

        <RouteWithLayout
          component={TeacherQLKyThi}
          exact
          layout={MainLayout}
          path="/quan-ly-ky-thi"
        />
        <RouteWithLayout
          component={TeacherQLMon}
          exact
          layout={MainLayout}
          path="/quan-ly-mon-hoc"
        />
        <RouteWithLayout
          component={TeacherViewExam}
          exact
          layout={MainLayout}
          path="/chi-tiet-bai-thi"
        />
        <RouteWithLayout
          component={TeacherViewExamTHPTQG}
          exact
          layout={MainLayout}
          path="/chi-tiet-bai-thi-thptqg"
        />
        <RouteWithLayout
          component={TeacherHanhTrinhLamBai}
          exact
          layout={MainLayout}
          path="/hanh-trinh-lam-bai"
        />
        <RouteWithLayout
          component={TeacherIndexEssay}
          exact
          layout={MainLayout}
          path="/danh-sach-bai-thi-tu-luan"
        />
        <RouteWithLayout
          component={TeacherIndexEssay}
          exact
          layout={MainLayout}
          path="/danh-sach-bai-thi-tu-luan-lop"
        />
        <RouteWithLayout
          component={TeacherChuaChamDiem}
          exact
          layout={MainLayout}
          path="/danh-sach-chua-cham-diem"
        />
        <RouteWithLayout
          component={TeacherChuaChamDiem}
          exact
          layout={MainLayout}
          path="/danh-sach-chua-cham-diem-lop"
        />
        <RouteWithLayout
          component={TeacherDaChamDiem}
          exact
          layout={MainLayout}
          path="/danh-sach-da-cham-diem"
        />
        <RouteWithLayout
          component={TeacherDaChamDiem}
          exact
          layout={MainLayout}
          path="/danh-sach-da-cham-diem-lop"
        />
        <RouteWithLayout
          component={TeacherScoreExamEssay}
          exact
          layout={MainLayout}
          path="/cham-diem-bai-thi"
        />
        <RouteWithLayout
          component={TeacherDeThiTuLuan}
          exact
          layout={MainLayout}
          path="/danh-sach-de-thi-tu-luan"
        />
        <RouteWithLayout
          component={PageTesting}
          exact
          layout={MainLayout}
          path="/testing"
        />
        <RouteWithLayout
          component={TeacherListTeacher}
          exact
          layout={MainLayout}
          path="/danh-sach-giao-vien"
        />
        <RouteWithLayout
          component={TeacherPrintExam}
          exact
          layout={MainLayout}
          path="/in-bai-thi"
        />
        <RouteWithLayout
          component={TeacherListTransfer}
          exact
          layout={MainLayout}
          path="/de-thi-da-chuyen"
        />
        <RouteWithLayout
          component={TeacherManageClass}
          exact
          layout={MainLayout}
          path="/danh-sach-giao-vien-quan-ly-lop"
        />
        <RouteWithLayout
          component={TeacherTaoDeThiTuNganHang}
          exact
          layout={MainLayout}
          path="/tao-de-thi-tu-ngan-hang"
        />
        <RouteWithLayout
          component={StudentDocument}
          exact
          layout={MainLayout}
          path="/tai-lieu-huong-dan"
        />
        <RouteWithLayout
          component={TeacherDSMauPhieuCham}
          exact
          layout={MainLayout}
          path="/danh-sach-mau-phieu-cham"
        />
        <RouteWithLayout
          component={TeacherMauPhieuCham}
          exact
          layout={MainLayout}
          path="/mau-phieu-cham"
        />
        <RouteWithLayout
          component={TeacherXuLyPhieuTraLoi}
          exact
          layout={MainLayout}
          path="/xu-ly-phieu-tra-loi"
        />
        <RouteWithLayout
          component={GradingRoundDetailView}
          exact
          layout={MainLayout}
          path="/xu-ly-phieu-tra-loi/:sessionId"
        />

        <RouteWithLayout
          component={NotFound}
          exact
          layout={MinimalLayout}
          path="/not-found"
        />
        <RouteWithLayout
          component={SsoError}
          exact
          layout={MinimalLayout}
          path="/sso-error"
        />
        <RouteWithLayout
          component={NotSupportRole}
          exact
          layout={MinimalLayout}
          path="/not-support-role"
        />

        <RouteWithLayout
          component={Home}
          layout={MinimalLayout}
          exact
          path="/"
        />
        <Redirect to="/not-found" />
      </Switch>
    </Suspense>
  );
};

export default Routes;
